export default function AboutSection() {
  const features = [
    {
      icon: 'ri-team-fill',
      title: 'Aktif Topluluk',
      description: 'Dünyanın dört bir yanından binlerce aktif oyuncuyla canlı ve dostane topluluğumuza katılın.',
      color: 'from-cyan-500 to-blue-500',
    },
    {
      icon: 'ri-puzzle-fill',
      title: 'Özel Eklentiler',
      description: 'Özel geliştirilmiş eklentilerimiz ve benzersiz özelliklerimizle eşsiz bir oyun deneyimi yaşayın.',
      color: 'from-lime-500 to-green-500',
    },
    {
      icon: 'ri-time-fill',
      title: '7/24 Aktif',
      description: 'Özel sunucularımız maksimum çalışma süresi sağlar, böylece istediğiniz zaman oynayabilirsiniz.',
      color: 'from-purple-500 to-pink-500',
    },
    {
      icon: 'ri-trophy-fill',
      title: 'Düzenli Etkinlikler',
      description: 'Harika ödüller içeren heyecan verici etkinliklere, yarışmalara ve meydan okumalara katılın.',
      color: 'from-orange-500 to-red-500',
    },
  ];

  return (
    <section id="about" className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <div className="inline-block px-4 py-2 bg-lime-400/20 rounded-full mb-4">
            <span className="text-lime-400 font-bold text-sm uppercase tracking-wider">Sunucu Özellikleri</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-white mb-4">
            Neden FurukoNetwork?
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl">
            Benzersiz özellikler ve harika bir toplulukla en iyi Minecraft survival sunucusunu deneyimleyin
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10 hover:border-cyan-400/50 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-cyan-500/20"
            >
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${feature.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
